export enum WdpPageVariant {
    READ,
    CREATE,
    CLONE,
}
